export const SET_LANGUAGE="app/language/SET_LANGUAGE"
